import { render } from "./itemquery.vue?vue&type=template&id=5cd272e9"
import script from "./itemquery.vue?vue&type=script&lang=js"
export * from "./itemquery.vue?vue&type=script&lang=js"

import "./itemquery.vue?vue&type=style&index=0&id=5cd272e9&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__